import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavController, Platform, IonicModule } from '@ionic/angular';
import { Router, NavigationExtras } from '@angular/router';

import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import * as en from './i18n/en.json';
import * as es from './i18n/es.json';
import * as pt from './i18n/pt.json';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    imports: [IonicModule, TranslatePipe]
})
export class HeaderComponent implements OnInit {
  customerColor = localStorage.getItem('cor')
  vehicleInfo;
  placa;

  mostrarAlerta = false;
  botoesAlerta: any[] = [];

  navestas = '';
  @Input() titleName;
  @Input() goTo?;
  @Input() navExtras?;

  constructor(
    private modalCtrl: ModalController,
    private navController: NavController,
    private router: Router,
    private platform: Platform,
    private translate: TranslateService
  ) {
    this.loadLocalTranslations();

    this.platform.backButton.subscribeWithPriority(10, () => {
    this.backBtn();
  });
  }

  ngOnInit() {}

  ionViewDidEnter() {
    console.log('header title', this.titleName);
    this.vehicleInfo = history.state.vehicleInfo;
    this.placa = this.vehicleInfo.placa;
  }

  loadLocalTranslations() {
    this.translate.setTranslation('en', en, true)
    this.translate.setTranslation('pt', pt, true)
    this.translate.setTranslation('es', es, true)
  }


  async confirmarSaida() {
    const msgCancel = await firstValueFrom(this.translate.get('CANCEL'));
    const msgConfirm = await firstValueFrom(this.translate.get('YES'));

    this.botoesAlerta = [
      {
        text: msgCancel,
        role: 'cancel',
      },
      {
        text: msgConfirm,
        role: 'confirm',
        handler: () => {
          if (this.goTo && this.navExtras) {
            const navExtras: NavigationExtras = { state: { data: this.navExtras } };
            this.router.navigate([`/${this.goTo}`], navExtras);
            return;
          } else {
            this.router.navigate([`/${this.goTo}`]);
          }
        }
      }
    ];

    this.mostrarAlerta = true;
  }

  async backBtn() {


    if (this.goTo) {
      this.confirmarSaida();
      return;
    }

    
    const modal = await this.modalCtrl.getTop();
    if (modal) {
      await modal.dismiss();
    } else {
      this.navController.back();
    }
  }
}
